<template>
    <EChart :options="chartOptions" card class="m-0" :header="$t('availabilityInTime')" :loading="requestAvailabilityChart.getLoading()">
        <template #nav>
            <div class="d-flex gap-3">
                <TimeRangeCalendar v-model="timeRange" />
                <ButtonIcon @click="fetchChartData()">{{ $t('loadData') }}</ButtonIcon>
            </div>
        </template>
    </EChart>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';

    export default {
        name: 'AvailabilityChart',
        components: {
            EChart,
            TimeRangeCalendar,
        },
        data() {
            return {
                requestAvailabilityChart: this.$req('offers/availabilityChart'),
                id: Number.parseInt(this.$route.params.id),
                timeRange: null,
            };
        },
        computed: {
            chartOptions() {
                const reportData = this.requestAvailabilityChart.getData()?.chart;
                if (!reportData) {
                    return { series: [] };
                }
                const series = reportData.map(item => ({
                    name: item.label,
                    type: 'rangeBar',
                    data: [{ name: item.label, data: item.segments.map(segment => ({ x: item.label, y: [segment.start, segment.end] })) }],
                }));

                return {
                    legend: {
                        show: true,
                    },
                    xAxis: {
                        type: 'time',
                    },
                    series,
                };
            },
        },
        methods: {
            fetchChartData() {
                this.requestAvailabilityChart.get({ urlParams: { offerId: this.id }, requestParams: { startDate: this.timeRange.startDate, endDate: this.timeRange.endDate }, cache: false });
            },
        },
    };
</script>
